/**
 * @module Theme
 */

import { Component, Input } from '@angular/core';
import { ItemColor } from '@functions/item.functions';
import { ThemeOptionsClass } from '@class/themeOptions.class';
import { ThemeOptionType } from '@models/themeStudio.model';

@Component({
  selector: 'app-theme-option-animation-duration',
  templateUrl: './theme-option-animation-duration.component.html',
  styleUrls: ['./theme-option-animation-duration.component.css']
})
export class ThemeOptionAnimationDurationComponent {

  @Input() themeOptions: ThemeOptionsClass;

  color = ItemColor('themes');
  optionType: ThemeOptionType = 'animation_duration';

  constructor() {}
  
  receiveValue(value: number) {
    this.themeOptions.setOption(this.optionType, value);
  }

}
